export const MAX_SIZE_UPLOAD = '7340032'; // 7MB
